import { render, staticRenderFns } from "./FeedbackPicture.vue?vue&type=template&id=cadcfdb2&"
import script from "./FeedbackPicture.vue?vue&type=script&lang=js&"
export * from "./FeedbackPicture.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackPicture.vue?vue&type=style&index=0&lang=less&"
import style1 from "./FeedbackPicture.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports